import { CONFIG } from '../config.js';
import { safeFetchClient } from '../utils/safe-fetch-client.js';

/**
 * Adaptador para la API de Reservas (Google Sheets Proxy).
 */
export const SheetsRepository = {
    /**
     * Consulta la ocupación actual para una fecha, turno y área.
     * GET — idempotent, retried automatically by safeFetchClient on transient errors.
     */
    async getOcupacion(fecha, turno, area) {
        const query = new URLSearchParams({ fecha, turno, area }).toString();
        const response = await safeFetchClient(`${CONFIG.API.RESERVAS}?${query}`);

        if (!response.ok) throw new Error('Error al consultar ocupación en repositorio');

        const data = await response.json();
        return data.ocupacion || 0;
    },

    /**
     * Envía una nueva reserva al servidor.
     * POST — NOT retried to avoid duplicate submissions.
     * The server-side dedupe cache provides the safety net for double-clicks.
     */
    async saveReserva(reservaData) {
        const response = await safeFetchClient(CONFIG.API.RESERVAS, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(reservaData),
        });

        const data = await response.json();

        if (!response.ok) {
            throw new Error(data.error || 'Error al guardar reserva en repositorio');
        }

        return data;
    }
};
